import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { useSessaoAtual } from 'services/app';
import { BoletoGetModel } from 'model/api/gestao/boleto/boleto-get-model';
import { NovoBoletoModel } from 'model/api/gestao/boleto/novo-boleto-model';

export function usePutBoleto() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<BoletoGetModel>();
    const { getEmpresa } = useSessaoAtual();

    const putBoleto = useCallback(
        (model: NovoBoletoModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/boleto/${model.id}`,
                data: {
                    ...model,
                    contratoId: getEmpresa().ContratoId
                },
                enviarTokenUsuario: true
            }),
        [getEmpresa, invocarApi],
    );
    return {
        ...outrasPropriedades,
        putBoleto,
    };
}
